export default store => store;
